<template>
    <div class="more-btn client-tag-hover-down">
        <div class=hover>
            <!-- 悬浮的按钮 -->
            <slot name="hoverBtn"></slot>
        </div>
        <div class=dropdown>
            <!-- 下拉框 -->
            <div class=default-dropdown>
                <div class=row>
                    <span>实名：</span>
                    <span v-text="tag.realNameBrandName"></span>
                </div>
                <div class=row>
                    <span>无盘：</span>
                    <span v-text="tag.disklessBrandName"></span>
                </div>
                <div class=row>
                    <span>计费：</span>
                    <span v-text="tag.billingBrandName"></span>
                </div>
                <div class=row>
                    <span>营销：</span>
                    <span v-text="tag.marketBrandName"></span>
                </div>
                <div class=row>
                    <span>文化：</span>
                    <span v-text="tag.cultureBrandName"></span>
                </div>
                <div class=row>
                    <span>链路速度：</span>
                    <span v-text="tag.linkSpeed"></span>
                </div>
                <div class=row>
                    <span>MAC：</span>
                    <span v-text="tag.mac"></span>
                </div>
                <div class=row>
                    <span>操作系统：</span>
                    <span v-text="tag.system"></span>
                </div>
                <div class=row>
                    <span>分辨率：</span>
                    <span v-text="tag.resolution"></span>
                </div>
                <div class=row>
                    <span>在线时长：</span>
                    <span v-text="onlineTimeMinSec(tag.onlineTime,tag.isOnline)"></span>
                </div>
                <div class=row>
                    <span>版本：</span>
                    <span v-text="tag.version"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { onlineTimeMinSec } from '_slib/time'
export default {
    name: 'hoverdownleft',
    props: {
        tag: {
            type: Object
        }
    },
    methods: {
        onlineTimeMinSec
    }
}
</script>

<style lang="scss" scoped>
.more-btn {
    display: inline-block;
    position: relative;
    height: 0px;
    margin-left: 6px;
    z-index: 4;
    width: 100%;

    .hover {
        cursor: pointer;
    }
    &:hover {
        z-index: 5;
        .dropdown {
            visibility: visible;
            opacity: 1;
            .default-dropdown {
                // top: 0px;
            }
        }
    }
    .dropdown {
        position: absolute;
        left: -10px;
        top: 10px;
        padding: 10px;
        visibility: hidden;
        overflow: hidden;
        min-width: 200px;
        z-index: 5;
        opacity: 0;
        transition: all 0.1s;
        .default-dropdown {
            // top: -220px;
            padding-top: 10px !important;
            padding-bottom: 10px !important;
            top: 8px;
            left: 0px;
            min-width: 160px;
            padding: 10px;

            span {
                display: inline-block;
                line-height: 22px;
            }
            span:nth-child(1) {
                width: 66px;
            }
        }
    }
}
.row > div {
    overflow: visible;
}
</style>

